import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=3daffb3e&scoped=true"
var script = {}
import style0 from "./contact.vue?vue&type=style&index=0&id=3daffb3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daffb3e",
  null
  
)

export default component.exports